import * as React from 'react';

import { mutationUpdateOneTalentProfile } from '@itp/prisma-talent/gql';
import { useMutation } from '@itp/talent/hooks';
import { useProfileContext } from '@itp/talent/pages/talentProfilePage/profileContext';

import { BoostCard } from './boostCard';

interface TalentBoostCardProps {
  onHide?: () => void;
}

export const TalentBoostCard: React.FC<TalentBoostCardProps> = ({ onHide }) => {
  const { isCreateMode, loading, profile, refetch } = useProfileContext();

  const [updateProfile] = useMutation(mutationUpdateOneTalentProfile, {
    messageSuccess: 'Profile boosted for 3 days!',
  });

  if (isCreateMode || loading || !profile) return null;

  const boostedUntil = (profile as any)?.boost?.boostedUntil ?? null;

  const handleBoost = async () => {
    const until = new Date();
    until.setDate(until.getDate() + 3);

    await updateProfile({
      variables: {
        data: {
          boost: {
            upsert: {
              create: { boostedUntil: until.toISOString() },
              update: { boostedUntil: until.toISOString() },
            },
          },
        },
        where: { id: (profile as any).id },
      },
    });
    await refetch();
  };
  if (boostedUntil && new Date(boostedUntil) > new Date()) return null;

  return (
    <BoostCard
      boostedUntil={boostedUntil}
      description="Move your profile to the top."
      onBoost={handleBoost}
      onHide={onHide}
      title="Boost your profile"
    />
  );
};
